export default function lazyLoad(selector = '.lazyload') {
	const lazyEls = document.querySelectorAll(selector);
	if (!lazyEls || lazyEls.length <= 0) return;

	const threshValue = window.innerWidth <= 768 ? 0.1 : 0.2;

	const options = {
		root: null,
		rootMargin: '0px',
		threshold: threshValue,
	};

	function callback(entries, observer) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				if (
					entry.target.tagName === 'IMG' &&
					entry.target.getAttribute('data-lazy-url')
				) {
					const img = entry.target;
					img.setAttribute('src', img.dataset.lazyUrl);
					img.removeAttribute('data-lazy-url');
				}
				entry.target.classList.add('lazyload--show');
				observer.unobserve(entry.target);
			}
		});
	}

	const observer = new IntersectionObserver(callback, options);
	lazyEls.forEach((el) => observer.observe(el));
}
